import React from 'react';
import { useDrag } from 'react-dnd';

const PALETTE_COMPONENTS = [
  {
    type: 'text',
    name: 'Text Block',
    icon: 'fas fa-font',
    description: 'Add text content'
  },
  {
    type: 'image',
    name: 'Image',
    icon: 'fas fa-image',
    description: 'Upload or link images'
  },
  {
    type: 'button',
    name: 'Button',
    icon: 'fas fa-mouse-pointer',
    description: 'Call-to-action button'
  },
  {
    type: 'banner',
    name: 'Hero Banner',
    icon: 'fas fa-panorama',
    description: 'Hero section with background'
  },
  {
    type: 'menu_section',
    name: 'Menu Section',
    icon: 'fas fa-utensils',
    description: 'Restaurant menu display'
  },
  {
    type: 'contact_form',
    name: 'Contact Form',
    icon: 'fas fa-envelope',
    description: 'Contact form with fields'
  },
  {
    type: 'two_column',
    name: 'Two Columns',
    icon: 'fas fa-columns',
    description: 'Side-by-side content'
  },
  {
    type: 'three_column',
    name: 'Three Columns',
    icon: 'fas fa-grip-horizontal',
    description: 'Three column layout'
  }
];

function DraggableComponent({ component }) {
  const [{ isDragging }, drag] = useDrag({
    type: 'COMPONENT',
    item: { type: component.type },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });

  return (
    <div 
      ref={drag}
      className={`palette-component ${isDragging ? 'dragging' : ''}`}
    >
      <div className="component-icon">
        <i className={component.icon}></i>
      </div>
      <div className="component-info">
        <h4>{component.name}</h4>
        <p>{component.description}</p>
      </div>
    </div>
  );
}

function ComponentPalette({ componentTypes, onAddComponent }) {
  return (
    <div className="component-palette">
      <div className="palette-header">
        <h3>
          <i className="fas fa-puzzle-piece me-2"></i>
          Components
        </h3>
        <p className="text-muted">Drag components to the canvas</p>
      </div>

      <div className="palette-search">
        <input 
          type="text" 
          placeholder="Search components..." 
          className="form-control"
        />
      </div>

      <div className="palette-categories">
        <div className="category">
          <h5>Basic Elements</h5>
          <div className="components-grid">
            {PALETTE_COMPONENTS.filter(comp => 
              ['text', 'image', 'button'].includes(comp.type)
            ).map(component => (
              <DraggableComponent 
                key={component.type}
                component={component}
              />
            ))}
          </div>
        </div>

        <div className="category">
          <h5>Layout</h5>
          <div className="components-grid">
            {PALETTE_COMPONENTS.filter(comp => 
              ['two_column', 'three_column'].includes(comp.type)
            ).map(component => (
              <DraggableComponent 
                key={component.type}
                component={component}
              />
            ))}
          </div>
        </div>

        <div className="category">
          <h5>Restaurant Specific</h5>
          <div className="components-grid">
            {PALETTE_COMPONENTS.filter(comp => 
              ['banner', 'menu_section', 'contact_form'].includes(comp.type)
            ).map(component => (
              <DraggableComponent 
                key={component.type}
                component={component}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="palette-footer">
        <small className="text-muted">
          <i className="fas fa-info-circle me-1"></i>
          Drag and drop to add components
        </small>
      </div>
    </div>
  );
}

export default ComponentPalette;